import { createSlice } from '@reduxjs/toolkit';
import {
	getCostCenterList,
	addNewCostCenter,
	updateCostCenter,
	deleteCostCenter,
	getCostCenter,
	importCostCenter,
} from '../costCenter/thunk';

export const initialState = {
	itemCostCenterList: [],
	itemCostCenterDetail: null,
	isCostCenterLoading: false,
	isCostCenterSuccess: false,
	isCostCenterImport: false,

	costCenterList: [],
	costCenterListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const CostCenterSlice = createSlice({
	name: 'CostCenter',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getCostCenter.fulfilled, (state, action) => {
			state.isCostCenterLoading = false;
			state.isCostCenterSuccess = true;
			state.itemCostCenterDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getCostCenter.pending, state => {
			state.isCostCenterLoading = true;
			state.isCostCenterSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getCostCenter.rejected, (state, action) => {
			state.isCostCenterLoading = false;
			state.isCostCenterSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getCostCenterList.pending, state => {
			state.isCostCenterSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getCostCenterList.fulfilled, (state, action) => {
			state.itemCostCenterList = action.payload;
			state.costCenterList = action.payload;
			state.isLoadingList = false;
			state.isCostCenterSuccess = true;

			let costCenterListSelect = [];
			action.payload.map(item =>
				costCenterListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.costCenterListSelect = costCenterListSelect;
		});
		builder.addCase(getCostCenterList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isCostCenterSuccess = true;
		});
		builder.addCase(addNewCostCenter.fulfilled, (state, action) => {
			state.itemCostCenterList.push(action.payload);
			state.costCenterList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewCostCenter.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewCostCenter.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateCostCenter.fulfilled, (state, action) => {
			state.itemCostCenterList = state.itemCostCenterList.map(cost_center =>
				cost_center.costCentername === action.payload.old_costCenter
					? { ...cost_center, ...action.payload.updated_costCenter }
					: cost_center
			);
			state.costCenterList = state.costCenterList.map(cost_center =>
				cost_center._id.toString() === action.payload._id.toString()
					? { ...cost_center, ...action.payload }
					: cost_center
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateCostCenter.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateCostCenter.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteCostCenter.fulfilled, (state, action) => {
			state.itemCostCenterList = current(state.itemCostCenterList).filter(
				item => item._id !== action.payload._id
			);
			state.costCenterList = current(state.costCenterList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteCostCenter.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteCostCenter.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		builder.addCase(importCostCenter.fulfilled, (state, action) => {
			state.isCostCenterImport = false;
			state.isLoadingList = false;
		});
		builder.addCase(importCostCenter.pending, state => {
			state.isCostCenterImport = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(importCostCenter.rejected, (state, action) => {
			state.isCostCenterImport = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
	},
});

export const { setRequireCloseModal } = CostCenterSlice.actions;

export default CostCenterSlice.reducer;
